<template>
<div class="row">
  <div class="col-sm-12">
    <!-- <div class="hidden"><label for="">{{computeMapData}}</label></div> -->
    <div v-if="chartHasNoData" class="chart-has-no-data">
      <img src="static/img/no_data.svg" style="">
      <!-- <b-notification type="is-custom" :active.sync="chartHasNoData">
                <strong>Info! &nbsp;</strong> No data available
              </b-notification> -->
    </div>
    <div v-else class="chart-wrapper">
      <div class="chart-stage">
        <highmaps :options="options" ref="highmaps"></highmaps>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import map_data from '@/assets/js-on/nigeria_map_data';
export default {
  name: 'state-map',
  props: ['relativeIndicator', 'selectedIndicator', 'appData', 'sourceClicked', 'yearClicked', 'indicatorClicked'],
  components: {},
  data() {
    var data = [
      ['ng-ri', 0],
      ['ng-kt', 1],
      ['ng-so', 2],
      ['ng-za', 3],
      ['ng-yo', 4],
      ['ng-ke', 5],
      ['ng-ad', 6],
      ['ng-bo', 7],
      ['ng-ak', 8],
      ['ng-ab', 9],
      ['ng-im', 10],
      ['ng-by', 11],
      ['ng-be', 12],
      ['ng-cr', 13],
      ['ng-ta', 14],
      ['ng-kw', 15],
      ['ng-la', 16],
      ['ng-ni', 17],
      ['ng-fc', 18],
      ['ng-og', 19],
      ['ng-on', 20],
      ['ng-ek', 21],
      ['ng-os', 22],
      ['ng-oy', 23],
      ['ng-an', 24],
      ['ng-ba', 25],
      ['ng-go', 26],
      ['ng-de', 27],
      ['ng-ed', 28],
      ['ng-en', 29],
      ['ng-eb', 30],
      ['ng-kd', 31],
      ['ng-ko', 32],
      ['ng-pl', 33],
      ['ng-na', 34],
      ['ng-ji', 35],
      ['ng-kn', 36]
    ];
    return {
      chartHasNoData: false,
      lsData: JSON.parse(this.$ls.get('car_other_dataset')),
      dataSources: ['MICS', 'NHMIS', 'NNHS', 'NDHS', 'NMIS', 'NARHS', 'IHME', 'World Bank', 'WHO-GHO', 'WUENIC'],
      series_data: [],
      optionSources: [],
      optionYear: [],
      selectedSource: this.sourceClicked,
      selectedYear: '',
      stateToShortCode: {
        Abia: 'ng-ab',
        Adamawa: 'ng-ad',
        'Akwa Ibom': 'ng-ak',
        Anambra: 'ng-an',
        Bauchi: 'ng-ba',
        Benue: 'ng-be',
        Borno: 'ng-bo',
        Bauchi: 'ng-ba',
        Bayelsa: 'ng-by',
        'Cross River': 'ng-cr',
        Delta: 'ng-de',
        Ebonyi: 'ng-eb',
        Edo: 'ng-ed',
        Ekiti: 'ng-ek',
        Enugu: 'ng-en',
        FCT: 'ng-fc',
        Gombe: 'ng-go',
        Imo: 'ng-im',
        Jigawa: 'ng-ji',
        Kano: 'ng-kn',
        Katsina: 'ng-kt',
        Kaduna: 'ng-kd',
        Kebbi: 'ng-ke',
        Kogi: 'ng-ko',
        Kwara: 'ng-kw',
        Lagos: 'ng-la',
        Nasarawa: 'ng-na',
        Niger: 'ng-ni',
        Ogun: 'ng-og',
        Ondo: 'ng-on',
        Osun: 'ng-os',
        Oyo: 'ng-oy',
        Plateau: 'ng-pl',
        Rivers: 'ng-ri',
        Sokoto: 'ng-so',
        Taraba: 'ng-ta',
        Yobe: 'ng-yo',
        Zamfara: 'ng-za'
      },
      optionStates: [
        "Abia",
        "Adamawa",
        "Akwa Ibom",
        "Anambra",
        "Bauchi",
        "Benue",
        "Borno",
        "National",
        "Bayelsa",
        "Cross River",
        "Delta",
        "Ebonyi",
        "Edo",
        "Ekiti",
        "Enugu",
        "FCT",
        "Gombe",
        "Imo",
        "Jigawa",
        "Kaduna",
        "Kebbi",
        "Kano",
        "Katsina",
        "Kogi",
        "Kwara",
        "Lagos",
        "Nasarawa",
        "Niger",
        "Ogun",
        "Ondo",
        "Osun",
        "Oyo",
        "Plateau",
        "Rivers",
        "Sokoto",
        "Taraba",
        "Yobe",
        "Zamfara"
      ],
      mapPlotData: null,
      options: {
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500
              },
              chartOptions: {
                height: 550
              }
            }
          ]
        },
        chart: {
          map: 'countries/ng/ng-all',
          borderColor: '#335cad',
          style: {
            "fontFamily": "'Open Sans', sans-serif",
            "fontSize": "12px"
          },
          // width: 500,
          height: 438
        },

        colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',
          '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'
        ],

        credits: {
          enabled: true,
          text: 'Map of Nigeria'
        },

        title: {
          text: 'Loading...',
          style: {
            fontSize: '16px',
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: '600'
          }
        },

        subtitle: {
          text: "Loading...",
          style: {
            fontSize: '11px',
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 'normal'
          }
        },

        exporting: {
          csv: {
            dateFormat: '%Y-%m-%d'
          }
        },

        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: 'middle',
            align: 'right'
          }
        },
        legend: {
          enabled: true,
          layout: 'vertical',
          align: 'right'
        },
        colorAxis: {
          // min: 0,
          // max: 100,
          minColor: '#E6E7E8',
          maxColor: '#114663'
        },

        plotOptions: {
          map: {
            allAreas: false,
            mapData: map_data, // Highcharts.maps['countries/ng/ng-all'],
            states: {
              hover: {
                color: '#BADA55'
              }
            },
            joinBy: "hc-key",
            dataLabels: {
              enabled: true,
              //format: '{point.name}',
              color: '#FFFFFF',
              formatter: function () {
                if (this.point.value) {
                  return this.point.name;
                }
              }
            },
            tooltip: {
              headerFormat: '<b>{series.name}</b><br>',
              pointFormat: '{point.name}: <b>{point.value:.2f}</b>'
            }
          }
        },
        series: [{
          data: data,
          name: 'Random Name',
        }],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                      "printChart",
                      "separator",
                      "downloadPNG",
                      "downloadJPEG",
                      "downloadPDF",
                      "downloadSVG",
                      "separator",
                      "downloadCSV",
                      "downloadXLS",
                      //"viewData",
                      "openInCloud"
                    ],
                    
              symbol: 'download',
              // symbolStrokeWidth: 2,
              // symbolFill: '#330033',
              // symbolStroke: '#b3d4fc'
            }
          }
        }
      },
    }
  },
  methods: {
    
    // Check info about these methods on index.vue
    getCurrentSourceOptions(indicator) {
      let sources = [];
      var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      for (var k in this.dataSources) {
        for (var i in statesByIndicatorByYear) {
          for (var j in statesByIndicatorByYear[i]) {
            if (i !== 'National') {
              let indicatorSource = indicator + ' -> ' + this.dataSources[k];
              let indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
              if (statesByIndicatorByYear[i][j][indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
                if (sources.indexOf(this.dataSources[k]) < 0)
                  sources.push(this.dataSources[k]);
                break;
              }
            }
          }
        }
      }
      this.optionSources = sources;
    },
    getYearOptionsWithData(indicator, source) {
      let years = [];
      let statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      let indicatorSource = indicator + ' -> ' + source;
      let indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
      this.optionStates.map((elem, index) => {
        if (elem !== 'National') {
          statesByIndicatorByYear[elem].map((el, i) => {
            if (el[indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
              if (years.indexOf(el[0]) < 0) {
                years.push(el[0])
              }
            }
          });
        }
      });
      this.optionYear = years
    },
    plotMap() {
      // Create the chart
      if (this.mapPlotData) {
        this.options.legend = {
          enabled: true,
          layout: 'horizontal',
          align: 'right'
        }
        this.options.series[0].data = Object.keys(this.stateToShortCode).map((elem, index) => {
          return [this.stateToShortCode[elem], this.mapPlotData[elem]];
        });
      }
    },
    // Handles computation for map data
    getMapData(indicator, source) {
      let indicatorNames = this.appData[0];
      let indicatorSource = indicator + ' -> ' + source;
      let indexOfIndicatorSource = indicatorNames.indexOf(indicatorSource);
      let data = this.appData.slice(1);
      let stateData = {};
      this.optionStates.map((state, index) => {
        stateData[state] = '';
        data.map((elem, index) => {
          if (this.selectedYear === elem[0] && state === elem[1]) {
            if (elem[indexOfIndicatorSource] === "") {
              stateData[state] = 0;
            } else {
              stateData[state] = elem[indexOfIndicatorSource];
            }
          }
        });
      });
      return stateData
    },
    // Sets highmaps options
    computeMapData(indicator, source, caller) { //this.$store.getters.getCARngMapData;
      this.mapPlotData = this.getMapData(indicator, source);
      this.options.title.text = indicator;
      this.options.subtitle.text = source + ' - ' + this.selectedYear;
      this.options.exporting.filename = indicator +" ("+ source +' - '+ this.selectedYear +")";
      this.options.series[0].name = source;
      let state = Object.keys(this.mapPlotData);
      let noDataCounter = 0;
      for (var i in state) {
        //Excluding national from the condition because national isn't included on the map
        if (state[i] !== 'National') {
          if (this.mapPlotData[state[i]] !== 0) {
            this.chartHasNoData = false;
            break;
          } else {
            noDataCounter++;
          }
        }
      }
      if (noDataCounter === state.length - 1)
        this.chartHasNoData = true;
      this.plotMap();
      return "Nigeria Map";
    },
    yearComputation(indicator, source) {
      this.getYearOptionsWithData(indicator, source);
      if (this.optionYear.length > 0) {
        this.selectedYear = this.optionYear.reduce(function(a, b) { return Math.max(a, b); });
      } else {
        this.selectedYear = 0;
      }
    }
  },
  computed: {

  },
  // updated() {
  //     if(this.selectedYear > 0){
  //         this.computeMapData();
  //     } else {
  //         this.chartHasNoData = true;
  //     }
  // },
  mounted() {
    if (this.lsData) {
      /**
       * The if statement below checks if the length of the selectedIndicator 
       * is greater than 1. Initially, the selectedIndicator is empty and so 
       * this method runs all computations using the indicators gotten from the table
       * i.e (Indicator and relatives)
       */
      if (this.selectedIndicator.length < 1) {
        this.getCurrentSourceOptions(this.relativeIndicator);
        let randomSource = Math.floor(Math.random() * this.optionSources.length);
          if (this.optionSources.indexOf('MICS')== -1){
        this.selectedSource = this.optionSources[0];
      }
      else {
        this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
      }

        this.yearComputation(this.relativeIndicator, this.selectedSource);
        // This checks if there's an available year for the current indicator and source
        // else it shows the noData chart
        if (this.selectedYear > 0) {
          this.computeMapData(this.relativeIndicator, this.selectedSource);
        } else {
          this.chartHasNoData = true;
        }
      } else {
        /**
         * This if checks if the indicator selected from other charts contains data
         * else it makes computations using the relative indicators from the table
         */
        if (this.indicatorClicked.length > 1) {
          this.getCurrentSourceOptions(this.indicatorClicked);
          let randomSource = Math.floor(Math.random() * this.optionSources.length);
          this.selectedSource = this.sourceClicked;
          this.yearComputation(this.indicatorClicked, this.selectedSource);
          this.selectedYear = this.yearClicked;
          if (this.selectedYear > 0) {
            this.computeMapData(this.indicatorClicked, this.selectedSource);
          } else {
            this.chartHasNoData = true;
          }
        } else {
          this.getCurrentSourceOptions(this.selectedIndicator);
          let randomSource = Math.floor(Math.random() * this.optionSources.length);
          this.selectedSource = this.sourceClicked;
          this.yearComputation(this.selectedIndicator, this.selectedSource);
          this.selectedYear = this.yearClicked;
          if (this.selectedYear > 0) {
            this.computeMapData(this.selectedIndicator, this.selectedSource);
          } else {
            this.chartHasNoData = true;
          }
        }
      }

    }
  },
  watch: {
    selectedIndicator(val) {
      this.getCurrentSourceOptions(this.relativeIndicator);
      let randomSource = Math.floor(Math.random() * this.optionSources.length);
      this.selectedSource = this.sourceClicked;
      
      if (this.selectedYear > 0) {
        this.computeMapData(val, this.selectedSource);
      } else {
        this.chartHasNoData = true;
      }
    },
    sourceClicked(val) {
      this.selectedSource = val;
      if (this.selectedIndicator !== '') {
        this.yearComputation(this.selectedIndicator, val);
        if (this.selectedYear > 0) {
          this.computeMapData(this.selectedIndicator, val);
        } else {
          this.chartHasNoData = true;
        }
      } else {
        this.yearComputation(this.relativeIndicator, val);
        if (this.selectedYear > 0) {
          this.computeMapData(this.relativeIndicator, val);
        } else {
          this.chartHasNoData = true;
        }
      }
    },
    yearClicked(val) {
      this.selectedYear = val;
      if (this.selectedIndicator !== '') {
        if (val > 0) {
          this.computeMapData(this.selectedIndicator, this.selectedSource);
        } else {
          this.chartHasNoData = true;
        }
      } else {
        if (val > 0) {
          this.computeMapData(this.relativeIndicator, this.selectedSource);
        } else {
          this.chartHasNoData = true;
        }
      }
    },
    indicatorClicked(val) {
      this.getCurrentSourceOptions(val);
      let randomSource = Math.floor(Math.random() * this.optionSources.length);
      this.selectedSource = this.sourceClicked;
      if (this.selectedYear > 0) {
        this.computeMapData(val, this.selectedSource);
      } else {
        this.chartHasNoData = true;
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// states.vue?3151b42d